import AddIcon from "@mui/icons-material/Add";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  TextField,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from "@mui/material";

import { getUnitPropertie } from "../../../smart/camunda/forms/functions";

export default class StepperModal {
  static DisplayTab(props) {
    const { onChange, state, onPropertieChange } = props;
    const stepperAdvanceLabel = getUnitPropertie(state, "stepperAdvanceLabel");
    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="id"
            variant="outlined"
            id="id"
            label="Id"
            value={state.id || ""}
            fullWidth
            helperText="Identificador único do componente"
          />
        </Grid>
      </Grid>
    );
  }

  static ValidationTab(props) {
    const { onPropertieChange, state, error } = props;

    const hasRequiredError =
      Array.isArray(error) && error?.some((e) => e.id === "steps");

    const steps = getUnitPropertie(state, "steps") || [];
    const effectiveSteps = steps.length ? steps : [{ id: 1, name: "" }];

    const reindexSteps = (arr) => arr.map((s, i) => ({ ...s, id: i + 1 }));

    const handleAddStep = () => {
      const newStep = {
        id: effectiveSteps.length + 1,
        name: "",
      };
      const updatedSteps = reindexSteps([...effectiveSteps, newStep]);
      if (onPropertieChange) {
        onPropertieChange({ target: { name: "steps", value: updatedSteps } });
      }
    };

    const handleRemoveStep = (index) => {
      if (index === 0) {
        return;
      }
      const base = steps.length ? steps : effectiveSteps;
      const updatedSteps = reindexSteps(base.filter((_, i) => i !== index));
      if (onPropertieChange) {
        onPropertieChange({ target: { name: "steps", value: updatedSteps } });
      }
    };

    const handleStepNameChange = (index, value) => {
      const updatedSteps = steps.length ? [...steps] : [...effectiveSteps];
      updatedSteps[index].name = value;
      if (onPropertieChange) {
        onPropertieChange({ target: { name: "steps", value: updatedSteps } });
      }
    };

    const handleMoveStep = (index, direction) => {
      if (
        (direction === "up" && index === 0) ||
        (direction === "down" && index === effectiveSteps.length - 1)
      ) {
        return;
      }

      const updatedSteps = steps.length ? [...steps] : [...effectiveSteps];
      const targetIndex = direction === "up" ? index - 1 : index + 1;
      [updatedSteps[index], updatedSteps[targetIndex]] = [
        updatedSteps[targetIndex],
        updatedSteps[index],
      ];

      const reindexed = reindexSteps(updatedSteps);
      if (onPropertieChange) {
        onPropertieChange({ target: { name: "steps", value: reindexed } });
      }
    };

    return (
      <Grid container spacing={3}>
        <Grid item size={12}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6">Etapas do formulário</Typography>
            <Typography variant="body2" color="textSecondary">
              Adicionar/Remover
            </Typography>
          </Box>

          {effectiveSteps.map((step, index) => (
            <Box
              key={step.id}
              display="flex"
              alignItems="flex-start"
              gap={16}
              mb={2}
              sx={{
                width: "100%",
              }}
            >
              <Box sx={{ width: "7%", minWidth: 30 }}>
                <TextField
                  label="Etapa"
                  value={step.id}
                  disabled
                  fullWidth
                  variant="outlined"
                  InputProps={{
                    sx: {
                      textAlign: "center",
                      "& .MuiInputBase-input": {
                        textAlign: "center",
                      },
                    },
                  }}
                />
              </Box>

              <Box sx={{ flexGrow: 1, position: "relative", right: "120px" }}>
                <TextField
                  label="Nome da etapa"
                  sx={{ width: "130%" }}
                  value={step.name}
                  onChange={(e) => handleStepNameChange(index, e.target.value)}
                  fullWidth
                  required
                  error={hasRequiredError && !step.name}
                  helperText={
                    hasRequiredError && !step.name
                      ? "Obrigatório informar o nome da etapa."
                      : ""
                  }
                  variant="outlined"
                />
              </Box>

              <Box
                display="flex"
                justifyContent="flex-end"
                mt={2}
                sx={{ position: "relative", right: "35px", top: "-10px" }}
              >
                <IconButton
                  onClick={() => handleRemoveStep(index)}
                  disabled={index === 0}
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: "8px",
                    border: "1px solid #d1d5db",
                    backgroundColor: "#fff",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    "&:hover": {
                      backgroundColor: "#f9fafb",
                    },
                  }}
                >
                  <RemoveIcon sx={{ color: "#555" }} />
                </IconButton>
              </Box>
            </Box>
          ))}

          <Box
            display="flex"
            justifyContent="flex-end"
            mt={2}
            sx={{ position: "relative", right: "35px" }}
          >
            <IconButton
              onClick={handleAddStep}
              sx={{
                width: 40,
                height: 40,
                borderRadius: "8px",
                backgroundColor: "#174EA6",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#1A5BD1",
                },
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              }}
            >
              <AddIcon />
            </IconButton>
          </Box>
        </Grid>
        <Box sx={{ height: 16 }} /> {/* Linha em branco de 16px */}
        <Grid item size={12}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6">Reordenar etapas</Typography>
            <Typography variant="body2" color="textSecondary">
              Subir/Descer
            </Typography>
          </Box>

          <TableContainer component={Paper} variant="outlined">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Etapa</TableCell>
                  <TableCell>Nome da etapa</TableCell>
                  <TableCell align="center" width={100}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {effectiveSteps.map((step, index) => (
                  <TableRow key={step.id}>
                    <TableCell>{step.id}</TableCell>
                    <TableCell>{step.name}</TableCell>
                    <TableCell align="center">
                      <Box display="flex" flexDirection="column" gap={0.5}>
                        <IconButton
                          size="small"
                          onClick={() => handleMoveStep(index, "up")}
                          disabled={index === 0}
                        >
                          <ArrowUpwardIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => handleMoveStep(index, "down")}
                          disabled={index === effectiveSteps.length - 1}
                        >
                          <ArrowDownwardIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {effectiveSteps.length > 0 && (
            <Box display="flex" justifyContent="center" mt={2}>
              <Typography variant="body2" color="textSecondary">
                {effectiveSteps.length} Linhas | 1 de{" "}
                {Math.ceil(effectiveSteps.length / 10)}
              </Typography>
            </Box>
          )}
        </Grid>
      </Grid>
    );
  }
}
